import { render } from "./ClusterWizard.vue?vue&type=template&id=453b9636&ts=true"
import script from "./ClusterWizard.vue?vue&type=script&lang=ts"
export * from "./ClusterWizard.vue?vue&type=script&lang=ts"

import "./ClusterWizard.vue?vue&type=style&index=0&id=453b9636&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__